import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx } from "@emotion/react";
import styled from "@emotion/styled";
import MuiTabs from "@material-ui/core/Tabs";
import MuiTab from "@material-ui/core/Tab";
import { withStyles } from "@material-ui/core/styles";
import { SentimentDissatisfied } from "@material-ui/icons";
import messages from "components/calendar/utils/messages";

const StyledTabs = styled(MuiTabs)((props) => ({
  height: props.height ?? "100%",
  minHeight: props.height ?? "100%",
  backgroundColor: props.theme.palette.background[1],
  borderBottomLeftRadius: 4,
  borderBottomRightRadius: 4,
  textTransform: "none",
  ".MuiTabs-fixed": {
    overflowX: "auto !important",
  },
  ".MuiTabs-flexContainer": {
    height: props.height ?? "100%",
    minHeight: props.height ?? "100%",
  },
  ".Mui-selected": {
    color: props.theme.palette.text.primary,
    // fontWeight: 500,
  },
  ".MuiTabs-indicator": {
    height: 3,
    // backgroundColor: props.theme.palette.text.primary,
    top: 0,
  },
}));

export const Tabs = withStyles((theme) => ({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      height: 3,
      maxWidth: 30,
      width: "100%",
      backgroundColor: theme.palette.text.primary,
    },
  },
}))((props) => (
  <StyledTabs {...props} TabIndicatorProps={{ children: <span /> }} />
));

export const Tab = styled(MuiTab)((props) => ({
  minWidth: "unset",
  paddingLeft: 16,
  paddingRight: 16,
  textTransform: "none",
  fontSize: "1rem",
  fontWeight: 400,
  letterSpacing: "0.25px",
}));
